import { render, staticRenderFns } from "./IconPreloader.vue?vue&type=template&id=7363eabd&scoped=true"
import script from "./IconPreloader.vue?vue&type=script&lang=js"
export * from "./IconPreloader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7363eabd",
  null
  
)

export default component.exports